import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { Info } from "@/assets/icons/icons";
import { SectionButtonHeader } from "@/components/Interface/SectionButtonHeader/SectionButtonHeader";
import { Tooltip } from "@/components/Interface/Tooltip/Tooltip";

export const RoamingCallExplanation = ({ title }: { title?: string }) => {
  const { t } = useTranslation("portal");

  return (
    <SectionButtonHeader className={clsx(title && "mb-4")} header={title}>
      <Tooltip
        position="bottom"
        className="right mr-5 mt-4 min-w-[250px] !px-6 !py-4 text-left text-base font-normal text-black sm:mr-6 md:mr-0 md:min-w-[327px]"
        content={
          <>
            <h3 className="block pb-2 text-lg font-semibold text-primary-100">
              {t("cockpit.managementTile.roaming.roamingCallHint.title")}
            </h3>
            <p className="pt-2">
              {t("cockpit.managementTile.roaming.roamingCallHint.text")}
            </p>
          </>
        }
      >
        <Info className="h-[21px] w-[21px] text-primary-100" />
      </Tooltip>
    </SectionButtonHeader>
  );
};
